import {
  OptimizerStatus,
  useCostAvoidanceForRangeQuery,
  type CostAvoidanceForRangeData
} from '@domain/schedule'
import {useUpmPlantContext} from '@hconnect/upm'
import {Skeleton, Typography} from '@mui/material'
import {usePlanningChartStartEnd} from '@widgets/planning-schedule-chart'

import {OptimizerScheduleType} from '../../types'

import {OptimizerSchedule} from './hooks/useOptimizerPlansOverview'

const ScheduleKPICell: React.FC<{
  scheduleId: number
  render: (data: CostAvoidanceForRangeData) => React.ReactElement
}> = ({scheduleId, render}) => {
  const {plantId} = useUpmPlantContext()
  const {startOfChart, endOfChart} = usePlanningChartStartEnd()
  const {data} = useCostAvoidanceForRangeQuery({
    plantId,
    scheduleId,
    from: startOfChart.toISOString(),
    to: endOfChart.toISOString()
  })

  if (!data) {
    return <Skeleton variant="text" />
  }

  return <Typography variant="h5">{render(data)}</Typography>
}

type OptimizerPlanTableKPICellParams = {
  schedule: OptimizerSchedule
  render: (data: CostAvoidanceForRangeData) => React.ReactElement
}

export const OptimizerPlanTableKPICell = ({schedule, render}: OptimizerPlanTableKPICellParams) => {
  if (
    schedule.type === OptimizerScheduleType.Calculating ||
    (schedule.type === OptimizerScheduleType.Optimized &&
      schedule.optimizationDetails.optimizerStatus === OptimizerStatus.Failed)
  ) {
    return <>-</>
  }

  return <ScheduleKPICell scheduleId={schedule.scheduleId} render={render} />
}
